import React from 'react';
import { Link } from 'react-router-dom';
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';

const PremiumEligibility = () => {
    return (
        <div className="page-wrapper">
            <div className="content">
                {/* Breadcrumb */}
                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                    <div className="my-auto mb-2">
                        <h2 className="mb-1">Premium Eligibility</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/employee-dashboard">
                                        <i className="ti ti-smart-home" />
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Premium Eligibility
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                        <div className="head-icons ms-2">
                            <CollapseHeader />
                        </div>
                    </div>
                </div>
                {/* /Breadcrumb */}

                <div className="card p-4 shadow-sm">
                    {/* <h4 className="mb-3">Rate for Addition / Deletion of Covered Lives</h4> */}
                    {/* <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="thead-light">
                                <tr>
                                    <th>Sum Insured / Age Band</th>
                                    <th>3M - 18Y</th>
                                    <th>19 - 35Y</th>
                                    <th>36 - 45Y</th>
                                    <th>46 - 55Y</th>
                                    <th>56 - 60Y</th>
                                    <th>61 - 65Y</th>
                                    <th>66 - 70Y</th>
                                    <th>71 - 75Y</th>
                                    <th>76 - 80Y</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[
                                    [50000, 4322, 5394, 6297, 8770, 13622, 17046, 20426, 24108, 27780],
                                    [100000, 4700, 7666, 8448, 12461, 19393, 24211, 29051, 34286, 39515],
                                    [150000, 5084, 8575, 9460, 14335, 22892, 29323, 34784, 41056, 47311],
                                    [200000, 5268, 9147, 10101, 15647, 25493, 33285, 39153, 46216, 53251],
                                    [250000, 6307, 10393, 11471, 17748, 28929, 37788, 44443, 52460, 60447],
                                    [300000, 7098, 11230, 12391, 19153, 31231, 40808, 47990, 56648, 65273],
                                    [350000, 8704, 12510, 13794, 21336, 34790, 45386, 53412, 63048, 72649],
                                    [400000, 9969, 13300, 14656, 22682, 36984, 48184, 56739, 66977, 77176],
                                    [450000, 11632, 14618, 16108, 24937, 39674, 52910, 62334, 73584, 84787],
                                    [500000, 12839, 15363, 16928, 26214, 40808, 55561, 65484, 77306, 89073],
                                    [600000, 13866, 16592, 18282, 28311, 48969, 66673, 78581, 92767, 106888],
                                    [700000, 16177, 19357, 21329, 33029, 57131, 77785, 91678, 108228, 124702],
                                    [800000, 18488, 22123, 24376, 37748, 65293, 88897, 104774, 123689, 142517],
                                    [900000, 20800, 24888, 27423, 42466, 73454, 100009, 117871, 139150, 160332],
                                    [1000000, 23111, 27653, 30470, 47185, 81616, 111121, 130968, 154611, 178146]
                                ].map((row, index) => (
                                    <tr key={index}>
                                        {row.map((cell, i) => (
                                            <td key={i}>{cell}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div> */}

                    <img src="./assets/img/insurance/GMC sheet 2025.jpg" alt="" style={{ height: "500px" }} />
                </div>
            </div>
            <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
                <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>

            </div>
        </div>
    );
};

export default PremiumEligibility;
